import { FC, useEffect } from 'react'
import { Col, Row, Text } from '@/client/components'
import { useGetTools } from '@/client/hooks'
import Page from '@/client/submodules/Page'
import { BlogContent } from './BlogContent'
import { BlogSide } from './BlogSide'
import { ScubscriptionPanel, BlogAuthor, BlogSearch, BlogCard } from './Components'
import { Featured } from './Featured'
import * as S from './styles'
import { BlogsProps } from './types'

export const Blogs: FC<BlogsProps> = ({
  seo,
  header,
  footer,
  meta,
  blogsLandingPage,
  content: {
    breadcrumb,
    name,
    description,
    tags,
    banner_image,
    content,
    search_result,
    search_placeholder,
    author_designation,
    author,
    author_image,
    social_media_link
  }
}) => {
  const { data } = useGetTools(meta['id'])
  useEffect(() => {}, [data])
  return (
    <Page seo={seo} header={header} footer={footer}>
      <Featured
        breadcrumb={breadcrumb}
        name={name}
        description={description}
        tags={tags}
        banner_image={banner_image}
        author={author}
        featured_media={seo?.featured_media || 0}
        seo={seo}
      />
      <S.Content>
        <Row>
          <Col xs='12' lg='9'>
            <S.SearchSetup>
              <BlogSearch search_placeholder={search_placeholder} search_result={search_result} />
            </S.SearchSetup>
            <BlogContent content={content}></BlogContent>
            <BlogAuthor
              author_designation={author_designation}
              author={author}
              author_image={author_image}
              social_media_link={social_media_link}
            ></BlogAuthor>
          </Col>
          <Col xs='12' lg='3'>
            <BlogSide content={blogsLandingPage['sidebar']} tags={tags} />
          </Col>
        </Row>
      </S.Content>
      <Row>
        <Col xs='12'>
          {data && data.length > 0 && (
            <>
              <Text as='h5' size='xlg' weight='bold'>
                {blogsLandingPage['related_topics_heading']}
              </Text>
            </>
          )}
          <S.Related>
            {data &&
              data.length > 0 &&
              data.map((blogItem) => (
                <S.SingleBlogCard key={`key_${blogItem}`}>
                  <BlogCard item={blogItem} />
                </S.SingleBlogCard>
              ))}
          </S.Related>
        </Col>
      </Row>
      <ScubscriptionPanel newsletter={blogsLandingPage['newsletter']} />
    </Page>
  )
}
